var _mask, _path, _rect, _path2, _rect2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeechIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1976_14559",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C4.34315 2 3 3.34315 3 5V8C3 9.65685 4.34315 11 6 11H11.0717L10.9666 12.7515C10.9393 13.208 11.4884 13.4587 11.8154 13.1389L14.0023 11H18C19.6569 11 21 9.65685 21 8V5C21 3.34315 19.6569 2 18 2H6Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0717 11L12.0699 11.0599L12.1334 10H11.0717V11ZM10.9666 12.7515L11.9649 12.8114L10.9666 12.7515ZM11.8154 13.1389L11.1161 12.424H11.1161L11.8154 13.1389ZM14.0023 11V10H13.5946L13.3031 10.2851L14.0023 11ZM4 5C4 3.89543 4.89543 3 6 3V1C3.79086 1 2 2.79086 2 5H4ZM4 8V5H2V8H4ZM6 10C4.89543 10 4 9.10457 4 8H2C2 10.2091 3.79086 12 6 12V10ZM11.0717 10H6V12H11.0717V10ZM11.9649 12.8114L12.0699 11.0599L10.0735 10.9401L9.96844 12.6917L11.9649 12.8114ZM11.1161 12.424C11.4431 12.1042 11.9922 12.3549 11.9649 12.8114L9.96844 12.6917C9.88632 14.0611 11.5337 14.8131 12.5146 13.8538L11.1161 12.424ZM13.3031 10.2851L11.1161 12.424L12.5146 13.8538L14.7015 11.7149L13.3031 10.2851ZM18 10H14.0023V12H18V10ZM20 8C20 9.10457 19.1046 10 18 10V12C20.2091 12 22 10.2091 22 8H20ZM20 5V8H22V5H20ZM18 3C19.1046 3 20 3.89543 20 5H22C22 2.79086 20.2091 1 18 1V3ZM6 3H18V1H6V3Z",
    fill: "black",
    mask: "url(#path-1-inside-1_1976_14559)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 18.5,
    width: 19,
    height: 3,
    rx: 0.5,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49997 18.5V16.5L4.49997 15",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.63497,
    y: 12.3969,
    width: 2,
    height: 3.11423,
    rx: 1,
    transform: "rotate(38.3591 5.63497 12.3969)",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5H14.5M6 5H18",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechIcon);
export default __webpack_public_path__ + "static/media/speech_icon.62c6da92458b34d7f175e07697fc1dfc.svg";
export { ForwardRef as ReactComponent };